<script>
  import { BASE_URL } from "../stores/BASE_URL"
  import { user } from "../stores/User"
  import { onMount } from "svelte"
  import { navigate } from "svelte-routing"
  import { verifySession } from "../services/verifySession"
  import Alert from "../components/Alert.svelte"

  let captcha = null
  let isLoading = false

  let alert = {
    show: false,
    message: "",
    status: "",
    time: 3000,
  }

  let codigo = ""

  const getCaptcha = async () => {
    let ops = "getCaptcha"
    let session_key = $user.session_key
    let url = `${BASE_URL}verificar.php?ops=${ops}&session_key=${session_key}`

    const response = await fetch(url)
    captcha = await response.json()

    codigo = ""
  }

  const verificarCaptcha = async () => {
    isLoading = true

    let formData = new FormData()
    formData.append("session_key", $user.session_key)
    formData.append("id_captcha", captcha.id_captcha)
    formData.append("codigo", codigo)
    formData.append("ops", "verificarCaptcha")

    const response = await fetch(`${BASE_URL}verificar.php`, {
      method: "POST",
      body: formData,
    })

    const resp = await response.json()

    alert = {
      show: false,
      message: "",
      status: "",
      time: 3000,
    }

    if (resp.status === "ok") {
      alert = {
        show: false,
        message: "Correcto",
        status: "success",
        time: 3000,
        key: alert.key + 1,
      }

      setTimeout(() => {
        alert.show = true
      }, 1)

      window.alert(
        "Verificado correctamente. Por favor, inicie sesión nuevamente.",
      )
      setTimeout(() => navigate("/", { replace: true }), 1000)
    } else {
      alert = {
        show: false,
        message: "Captcha incorrecto",
        status: "danger",
        time: 3000,
        key: alert.key + 1,
      }

      setTimeout(() => {
        alert.show = true
      }, 1)
    }

    isLoading = false
  }

  // Verificación de sesión al montar el componente
  onMount(() => {
    if (!$user) {
      navigate("/", { replace: true })
    } else {
      verifySession($user.session_key)
      if ($user.verificar == "0") {
        navigate("/", { replace: true })
      }
    }
  })

  getCaptcha()
</script>

<main>
  <div
    class="text-center vh-100 d-flex justify-content-center align-items-center"
  >
    <div class="p-12 bg-white shadow-sm rounded form-verificar">
      <h5>Verificación requerida</h5>
      <p class="fg-secondary">Por favor, resuelve el captcha para continuar.</p>

      {#if captcha}
        <picture>
          <img src={captcha.image} alt="CAPCHA" class="img-fluid" />
        </picture>
      {/if}

      <input
        type="text"
        class="form-control text-center mt-5 mb-3"
        placeholder="Escribe el texto de la imagen"
        bind:value={codigo}
      />

      {#if alert.show}
        <Alert
          key={alert.key}
          message={alert.message}
          status={alert.status}
          time={alert.time}
        />
      {/if}

      <div class="d-flex justify-content-between mt-3">
        <button class="btn btn-solid theme-secondary" on:click={getCaptcha}
          ><i class="bi bi-arrow-clockwise"></i></button
        >

        {#if isLoading}
          <button class="btn btn-solid theme-primary px-5 disabled"
            >Verificando...</button
          >
        {:else}
          <button
            class="btn btn-solid theme-primary px-5"
            on:click={verificarCaptcha}>Verificar</button
          >
        {/if}
      </div>
    </div>
  </div>
</main>

<style>
  .form-verificar {
    max-width: 400px;
  }
</style>
